@if ((currentSite$ | async); as site) {
  <mat-card>
    <mat-card-header>
      <mat-card-title style="width: 100%;">
        <mat-icon>design_services</mat-icon>&nbsp;&nbsp;{{'activate_advanced_features' | transloco}}?
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p [innerText]="'activate_advanced_features_description' | transloco: {site: site.name, ttl: site.structureTtlHours}"></p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button (click)="dialogRef.close(false)">{{'cancel' | transloco}}</button>
      <button mat-button
        cdkFocusInitial
        color="primary"
      (click)="dialogRef.close(true)">{{'activate' | transloco}}</button>
    </mat-card-actions>
  </mat-card>
}
